export default __webpack_public_path__ + "static/media/pdv.f3e6acb7.png";